<section class="leads-page">
  <div class="leads-toolbar">
    <div class="leads-filters">
      <label class="cg-admin-field leads-filters__field">
        <span class="cg-admin-field__label">Search</span>
        <input
          class="cg-input"
          type="search"
          [(ngModel)]="searchInput"
          (ngModelChange)="onSearchChange()"
          name="search"
          placeholder="Name, email, phone"
        />
      </label>
      <app-crm-list-filters-dropdown
        [assignedToValue]="ownerUserId"
        [statusValue]="statusId"
        [destinationValue]="preferredDestination"
        [assignedToOptions]="assignedToFilterOptions()"
        [statusOptions]="statusFilterOptions()"
        [destinationOptions]="destinationFilterOptions()"
        (assignedToChange)="onAssignedToFilterChange($event)"
        (statusChange)="onStatusFilterChange($event)"
        (destinationChange)="onDestinationFilterChange($event)"
        (cleared)="onFiltersClear()"
      />
      <label class="cg-admin-field leads-filters__field">
        <span class="cg-admin-field__label">From</span>
        <input class="cg-input" type="date" [(ngModel)]="createdFrom" (ngModelChange)="onFilterChange()" name="from" />
      </label>
      <label class="cg-admin-field leads-filters__field">
        <span class="cg-admin-field__label">To</span>
        <input class="cg-input" type="date" [(ngModel)]="createdTo" (ngModelChange)="onFilterChange()" name="to" />
      </label>
    </div>
    <div class="leads-toolbar__actions">
      <div class="leads-toolbar__toggles">
        <label class="leads-toolbar__archive">
          <input
            type="checkbox"
            [ngModel]="ownerUserId === 'me'"
            (ngModelChange)="onAssignedToMeToggle($event)"
            name="assignedToMe"
          />
          Show applicants assigned to me
        </label>
        <label class="leads-toolbar__archive">
          <input type="checkbox" [(ngModel)]="showArchived" (ngModelChange)="onFilterChange()" name="showArchived" />
          Show archived
        </label>
        <label class="leads-toolbar__archive">
          <input
            type="checkbox"
            [(ngModel)]="showDisqualified"
            (ngModelChange)="onFilterChange()"
            name="showDisqualified"
          />
          Show Disqualified Applicants
        </label>
      </div>
      @if (showImport() || showExport()) {
        <div class="leads-toolbar__file-actions">
          @if (showImport()) {
            <input
              #importInput
              class="leads-toolbar__file-input"
              type="file"
              accept=".xlsx,.xls,.csv"
              (change)="onImportFileSelected($event)"
            />
            <app-admin-button
              class="leads-toolbar__export"
              variant="secondary"
              type="button"
              [disabled]="!canImport() || loading() || importing()"
              (click)="openImportPicker()"
            >
              {{ importing() ? 'Importing…' : 'Import' }}
            </app-admin-button>
          }
          @if (showExport()) {
            <app-admin-button
              class="leads-toolbar__export"
              variant="secondary"
              type="button"
              [disabled]="!canExport() || loading() || exporting()"
              (click)="exportApplicants()"
            >
              {{ exporting() ? 'Exporting…' : 'Export' }}
            </app-admin-button>
          }
        </div>
      }
    </div>
  </div>

  <app-admin-table>
    <thead>
      <tr>
        <th>Name</th>
        <th>Contact</th>
        <th>Preferred destination</th>
        <th>Assigned to</th>
        <th>Created</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      @if (loading()) {
        <tr>
          <td colspan="6"><p class="cg-form-help">Loading applicants…</p></td>
        </tr>
      } @else if (applicants().length === 0) {
        <tr>
          <td colspan="6">
            <app-admin-empty-state
              icon="users"
              title="No applicants"
              description="Applicants created from converted leads will appear here."
            />
          </td>
        </tr>
      } @else {
        @for (applicant of applicants(); track applicant._id) {
          <tr [class.leads-row--archived]="applicant.isArchived">
            <td>
              <a class="cg-admin-link" [routerLink]="['/platform/applicants', applicant._id]"><strong>{{ applicant.fullName }}</strong></a>
              @if (applicant.subStatus?.name; as subStatusName) {
                <div class="leads-name-substatus"><strong>{{ subStatusName }}</strong></div>
              }
              @if (applicant.latestNote || applicant.message; as notePreview) {
                <app-lead-message-preview
                  [message]="notePreview"
                  [modalTitle]="'Note — ' + applicant.fullName"
                />
              }
            </td>
            <td>
              @if (displayContactEmail(applicant.email); as email) {
                <div>{{ email }}</div>
              }
              <div [class.cg-form-help]="displayContactEmail(applicant.email).length > 0">
                {{ applicant.phoneNumber }}
              </div>
            </td>
            <td><code class="cg-input--mono">{{ applicant.preferredDestination || '—' }}</code></td>
            <td>{{ applicant.owner?.displayName || '—' }}</td>
            <td>{{ applicant.createdAt | date: 'medium' }}</td>
            <td>{{ applicant.status.name }}</td>
          </tr>
        }
      }
    </tbody>
  </app-admin-table>

  @if (!loading()) {
    <div class="leads-pagination">
      <span class="cg-form-help">{{ pageSummary() }}</span>
      <div class="leads-pagination__actions">
        <label class="leads-pagination__page-size">
          <span class="cg-form-help">Rows</span>
          <select class="cg-select" [(ngModel)]="pageSize" (ngModelChange)="onFilterChange()" name="pageSize">
            @for (n of pageSizeOptions; track n) {
              <option [value]="n">{{ n }}</option>
            }
          </select>
        </label>
        <app-admin-button variant="secondary" type="button" [disabled]="page() <= 1 || loading()" (click)="goToPage(page() - 1)">
          Previous
        </app-admin-button>
        <app-admin-button variant="secondary" type="button" [disabled]="!hasNextPage() || loading()" (click)="goToPage(page() + 1)">
          Next
        </app-admin-button>
      </div>
    </div>
  }
</section>
